export default __webpack_public_path__ + "static/media/img_vision_05_w.9600c3d9.png";